import * as R from "ramda";
import {createReducer} from "./index";

////////////////////////////////////////////////////////////////////////////////
///////////////////////////////////  ACTIONS  //////////////////////////////////
////////////////////////////////////////////////////////////////////////////////

export const EQUIP_ITEM = 'EQUIP_ITEM';

////////////////////////////////////////////////////////////////////////////////
///////////////////////////////  ACTION CREATORS  //////////////////////////////
////////////////////////////////////////////////////////////////////////////////

export const equipItem = (item, slot) => ({type: EQUIP_ITEM, payload: {item, slot}});

////////////////////////////////////////////////////////////////////////////////
///////////////////////////////////  THUNKS  ///////////////////////////////////
////////////////////////////////////////////////////////////////////////////////

////////////////////////////////////////////////////////////////////////////////
///////////////////////////////////  REDUCER  //////////////////////////////////
////////////////////////////////////////////////////////////////////////////////

const initialState = {
  head: null,
  body: null,
  weapon: null,
  wing: null,
  ring: null,
};

export const characterReducer = createReducer(initialState, {
  // [ACTION_TYPE]: (state, action) => state,
  [EQUIP_ITEM]: (state, action) => R.set(R.lensPath([action.payload.slot]), action.payload.item)(state),
});

